import { FileBarChart } from "lucide-react";
import type { Card } from "../../types/chat";

interface Props {
  card: Card;
}

export function SummaryCard({ card }: Props) {
  const title = (card.data.title as string) ?? "Summary";
  const sections = (card.data.sections as Array<{ heading: string; content: string }>) ?? [];

  return (
    <div className="rounded-lg border bg-card p-3" role="region" aria-label="Summary">
      <div className="flex items-center gap-2 mb-2">
        <FileBarChart className="size-4 text-muted-foreground" />
        <span className="text-sm font-medium">{title}</span>
      </div>
      {card.data.summary != null && <p className="text-sm text-muted-foreground mb-2">{String(card.data.summary)}</p>}
      {sections.map((section, i) => (
        <div key={i} className="mt-1.5">
          <p className="text-xs font-medium">{section.heading}</p>
          <p className="text-xs text-muted-foreground">{section.content}</p>
        </div>
      ))}
    </div>
  );
}
